import { IClientSocket } from "@clairejs/core";

export abstract class AbstractClientSocketManager {
    abstract create(): IClientSocket;
    abstract joinChannels(channels: string[]): void;
    abstract leaveChannels(channels: string[]): void;
    abstract getPingMs(): number;
}
